import React, { Component } from 'react';
import classNames from 'classnames';
import Takeover from '../takeover';
import Facets from './facets';
import Monitor from '../search-result/monitor';
import './styles.scss';

class Filters extends Component {

    state = {
        isOpen: false,
        isTakeover: false
    };

    setVisibility() {
        this.setState({
            isOpen: !this.state.isOpen
        });
    }

    toggleTakeover() {
        this.setState({
            isTakeover: !this.state.isTakeover
        });
    }


    render() {

        const props = this.props;

        return (
            <>
                <section className={classNames({
                    'filters': true,
                    'filters--is-open': this.state.isOpen
                })}>
                    <div className="filters__toggle-container">
                        <button className="filters__toggle-filters" 
                            type="button" 
                            onClick={() => this.setVisibility(!this.state.isOpen)}>{this.state.isOpen ? 'Dölj filter' : 'Visa filter' }</button>
                    </div>
                    <Facets {...props} />
                    {props.useControls &&
                        <div className="filters__right-controls">
                            {/*
                            <button type="button" 
                                    className="filters__follow" 
                                    onClick={() => this.toggleTakeover(!props.isTakeover)}><span>Bevaka</span></button>
                            */}
                            <button type="button" 
                                    className={classNames({
                                        'filters__toggle-view': true,
                                        'filters__toggle-view--small': true,
                                        'filters__toggle-view--is-table': !props.isMapView
                                    })}
                                    onClick={() => props.setMapView(!props.isMapView)}><span>{props.isMapView ? 'Visa tabellvy' : 'Visa kartvy'}</span></button>
    
                            <button type="button" 
                                    className={classNames({
                                        'filters__toggle-view': true,
                                        'filters__toggle-view--large': true,
                                        'filters__toggle-view--is-table': props.isTableView
                                    })}
                                    onClick={() => props.setTableView(!props.isTableView)}><span>{props.isTableView ? 'Visa kartvy' : 'Visa tabellvy'}</span></button>
                        </div>
                    }
                </section>
                <Takeover isOpen={this.state.isTakeover} toggleTakeover={() => this.toggleTakeover()} heading="Bevaka sökningen">
                    <Monitor isOpen={this.state.isTakeover} toggleTakeover={() => this.toggleTakeover()} search={props.search} />
                </Takeover>
            </>
        );
    } 
};

export default Filters;
